/**
 * @generated SignedSource<<5f5a3e1d892b524b75c7a7408b7fd4f8>>
 * @relayHash 564337dbab683def385b386089972b3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0195a556cc8d68c6c38988b8e91ce0aa490d450932095e5a91f0fd9c51c8ad27

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type OrganizationDetailsPageQuery$variables = {
  cloudId: string;
  organizationId: string;
};
export type OrganizationDetailsPageQuery$data = {
  readonly customerService: {
    readonly organizationByOrganizationId: {
      readonly __typename: "CustomerServiceOrganization";
      readonly details: {
        readonly " $fragmentSpreads": FragmentRefs<"CustomDetailsSidebar">;
      };
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"ThrowOnQueryError">;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
  };
};
export type OrganizationDetailsPageQuery = {
  response: OrganizationDetailsPageQuery$data;
  variables: OrganizationDetailsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "organizationId",
    "variableName": "organizationId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v8 = {
  "kind": "ScalarField",
  "name": "message"
},
v9 = {
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "errorType"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "OrganizationDetailsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "args": (v1/*: any*/),
          "concreteType": "CustomerServiceQueryApi",
          "kind": "LinkedField",
          "name": "customerService",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v2/*: any*/),
                "kind": "LinkedField",
                "name": "organizationByOrganizationId",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "details",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "CustomDetailsSidebar"
                          }
                        ]
                      }
                    ],
                    "type": "CustomerServiceOrganization"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "extensions",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "ThrowOnQueryError"
                      }
                    ],
                    "type": "QueryError"
                  }
                ]
              },
              "action": "THROW",
              "path": "customerService.organizationByOrganizationId"
            }
          ]
        },
        "action": "THROW",
        "path": "customerService"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrganizationDetailsPageQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "CustomerServiceQueryApi",
        "kind": "LinkedField",
        "name": "customerService",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "organizationByOrganizationId",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "details",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isCustomerServiceCustomDetailValuesQueryResult"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "CustomerServiceCustomDetailValue",
                            "kind": "LinkedField",
                            "name": "results",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "canEdit"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "value"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "values"
                              },
                              {
                                "concreteType": "CustomerServiceCustomDetailType",
                                "kind": "LinkedField",
                                "name": "type",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "options"
                                  }
                                ]
                              },
                              {
                                "concreteType": "CustomerServiceCustomDetailConfigMetadata",
                                "kind": "LinkedField",
                                "name": "config",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "CustomerServiceCustomAttributeStyleConfiguration",
                                    "kind": "LinkedField",
                                    "name": "styleConfiguration",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CustomerServiceCustomAttributeOptionsStyleConfiguration",
                                        "kind": "LinkedField",
                                        "name": "options",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "optionValue"
                                          },
                                          {
                                            "concreteType": "CustomerServiceCustomAttributeOptionStyle",
                                            "kind": "LinkedField",
                                            "name": "style",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "backgroundColour"
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "type": "CustomerServiceCustomDetailValues"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ],
                        "type": "QueryError"
                      }
                    ]
                  }
                ],
                "type": "CustomerServiceOrganization"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "type": "QueryError"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0195a556cc8d68c6c38988b8e91ce0aa490d450932095e5a91f0fd9c51c8ad27",
    "metadata": {},
    "name": "OrganizationDetailsPageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "cca85a63efa4d2afa7aa698035d4c639";

export default node;
